export const FULL_ROTATION = 360
